import { ASK_AIRA_ANALYTICS } from './constants';


export const sendPromptApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/sendPrompt`;
  return request(url, getAPICallObject('POST', payload), 600000);
};

export const modifySQLApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/modifySQL`;
  return request(url, getAPICallObject('POST', payload), 600000);
};

export const fetchDataApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/fetchData`;
  return request(url, getAPICallObject('POST', payload), 600000);
};

export const upvoteQueryApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/upvoteQuery`;
  return request(url, getAPICallObject('POST', payload));
};

export const downvoteQueryApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/downvoteQuery`;
  return request(url, getAPICallObject('POST', payload));
};

export const getSuggestionApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/getSuggestions`;
  return request(url, getAPICallObject('POST', payload));
};

export const sendLogApi = (request, getAPICallObject) => payload => {
  const url = `${ASK_AIRA_ANALYTICS}/sendLog`;
  return request(url, getAPICallObject('POST', payload));
};
